import React from "react";

import './_working_hours.scss'
import {Breadcrumb, BreadcrumbItem, Column, Grid, Tile} from "@carbon/react";
import {Link} from "react-router-dom";
import ShiftsTable from "../../../components/ShiftsTable";

const WorkingHours = () => {
  return (
    <Grid fullWidth className="working-hours-page">
      <Column lg={16} md={8} sm={4}>
        <Grid className="page-banner">
          <Column lg={16} md={4} sm={4}>
            <Breadcrumb noTrailingSlash aria-label="Page navigation">
              <BreadcrumbItem>
                <Link to='/'>Home</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <Link to='/users/list'>Operatori</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                Turni
              </BreadcrumbItem>
            </Breadcrumb>
          </Column>
          <Column lg={16} md={4} sm={4}>
            <h1 className="page-heading">
              Turni
            </h1>
          </Column>
        </Grid>
        <Grid>
          <Column lg={16} md={8} sm={4} className="working-hours-page__r1">
            <Tile>
              <ShiftsTable/>
            </Tile>
          </Column>
        </Grid>
      </Column>
    </Grid>
  )
}

export default WorkingHours